import RewardsService from 'typescript/services/rewards_service';
import {
  RedeemRedemptionCodeRequest,
  RedeemRedemptionCodeResponse,
} from 'rpc/model/squareup/rewards/service';

export const redeemRedemptionCode = async (
  code: string,
): Promise<RedeemRedemptionCodeResponse.Status> => {
  const response = await RewardsService.redeemRedemptionCode(
    RedeemRedemptionCodeRequest.create({
      rewardCodeToken: code,
    }),
  );

  return response.status;
};
